var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSinglePageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8551_39964)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1.75736 22.2426C3.5147 24 6.34311 24 11.9999 24C17.6567 24 20.4852 24 22.2425 22.2426C23.9999 20.4852 23.9999 17.6567 23.9999 11.9999C23.9999 6.34311 23.9999 3.5147 22.2425 1.75736C20.4852 -1.4305e-07 17.6567 0 11.9999 0C6.34311 0 3.5147 -1.4305e-07 1.75736 1.75736C-1.4305e-07 3.5147 0 6.34319 0 12.0001C0 17.6568 -1.4305e-07 20.4852 1.75736 22.2426Z",
    fill: "#D0D3DC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 16,
    height: 10,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 8,
    height: 10,
    rx: 1,
    fill: "#61739F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8551_39964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglePageIcon);
export default __webpack_public_path__ + "static/media/SinglePageIcon.467eb69884fad5e9061bfc19d3a75a1a.svg";
export { ForwardRef as ReactComponent };